import React from 'react';
import { withRouter } from "react-router";
import { API } from "aws-amplify";
import { toast } from "react-toastify";
import _ from "lodash";

import Modal from "@/common/Modal";

import CreateConsortium from "./CreateConsortium";

function SupportToolsConsortiums(props) {
    const [consortiums, setConsortiums] = React.useState([]);
    const [createOpen, setCreateOpen] = React.useState(false);

    const loadConsortiums = () => {
        API.get('Core', '/api/v1/consortium')
            .then(response => {
                setConsortiums(Object.assign([], response));
            },
                error => {
                    toast("Could not load consortiums: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    React.useEffect(() => {
        loadConsortiums();
    }, []);

    const onConsortiumCreateSuccess = () => {
        loadConsortiums();
        setCreateOpen(false);
    }

    return (
        <div className="scrollView">

            <div className="">
                <Modal
                    button={(
                        <div
                            className="addButton"
                            tabIndex={0}
                            role="button"
                            aria-label="Create Consortium"
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setCreateOpen(true); } }}
                        >
                            <div className="buttonIcon" aria-hidden="true" />
                            <div className="buttonTitle">Create Consortium</div>
                        </div>
                    )}
                    content={(<CreateConsortium onSuccess={onConsortiumCreateSuccess} />)}
                    title="Create Consortium"
                    size="large"
                    handleClose={() => setCreateOpen(false)}
                    handleOpen={() => setCreateOpen(true)}
                    open={createOpen}
                />

            </div>

            <div className="surveysList tableView">
                <div className="tableSection">
                    {
                        _.map(_.sortBy(consortiums, function (t) {
                            return t.name;
                        }), function (consortium, k) {
                            return (
                                <div className="tableCell tenantCell" key={k}>
                                    <div className="cellBody">
                                        {consortium.name ?
                                            <div className="title">{consortium.name.length > 35 ? consortium.name.substring(0, 35) + '...' : consortium.name}</div> :
                                            <div className="title">{""}</div>
                                        }
                                        <div className="subtitle">Consortium {consortium.id}</div>
                                    </div>

                                    <div
                                        onClick={() => { props.history.push('/support-tools/consortium/' + consortium.id); }}
                                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.history.push('/support-tools/consortium/' + consortium.id); } }}
                                        className="button small action"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={`Manage ${consortium.name}`}
                                    >
                                        <div className="buttonTitle">Manage</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default withRouter(SupportToolsConsortiums);